export const containsAlphaNumeric = (name: string) => /\d|[A-Za-z]/.test(name);
